import logo from './logo.svg';
import './App.css';
import RegistrationForm from './RegistrationForm';

function App() {
  return (
    <div className="">
      <RegistrationForm />
    </div>
  );
}

export default App;
